import { createContext } from 'react'
import { GameContextValue } from './types'

export default createContext<GameContextValue>({} as GameContextValue)
